<template>
    <div class="withdrawal bgc box-shadow">
        <div class="top">
            <p>余额提现</p>
        </div>
        <div class="info_box ktxye">
            <span>可提现余额(元)：</span>
            <span>{{accountinfo.cashbalance}}</span>
        </div>
        <div class="info_box">
            <span>到帐账户：</span>
            <div class="select_box">
                <div class="select_box_top">
                    <el-radio-group v-model="tabPosition" @change="tabChange">
                        <el-radio-button label="wxzh">微信零钱</el-radio-button>
                        <el-radio-button label="zfb">支付宝</el-radio-button>
                        <el-radio-button label="yhk">银行卡</el-radio-button>
                        <el-radio-button label="zhye">账户余额</el-radio-button>
                    </el-radio-group>
                </div>
                <div class="select_box_bottom">
                    <div class="zhye_box" v-if="tabPosition === 'zhye'">
                        <p>
                            <span>商家账户名称：</span>
                            <span>{{accountinfo.linkman}}</span>
                            <span>账户手机号：</span>
                            <span>{{accountinfo.linktel}}</span>
                        </p>
                        <!--<p>温馨提示:转至账户余额的票款不能在从余额提取出来!</p>-->
                    </div>
                    <div class="wxzh_box" v-else-if="tabPosition === 'wxzh'">
                        <!--未授权-->
                        <div class="noAuthorize" v-if="wxinfo.bindstatus===0">您还未进行微信授权！<span @click="goAuthorize">点击去授权 ></span></div>
                        <!--已授权-->
                        <div class="hasAuthorize" v-if="wxinfo.bindstatus===1">
                            <p>提现微信：<span><img :src="wxinfo.wxheadurl" alt="">{{wxinfo.wxnickname}}</span></p>
                            <p>不是此微信，<span class="goAuthorize" @click="goAuthorize">重新授权 ></span></p>
                        </div>
                    </div>
                    <div class="zfb_box" v-else-if="tabPosition === 'zfb'">
                        <div>
                            <span>支付宝账号姓名：</span>
                            <el-input placeholder="支付宝账号姓名" v-model="recentalipayinfo.accountname" clearable></el-input>
                        </div>
                        <div>
                            <span>支付宝账号：</span>
                            <el-input placeholder="输入支付宝账号" v-model="recentalipayinfo.accountno" clearable></el-input>
                        </div>
                    </div>
                    <div class="yhk_box" v-else-if="tabPosition === 'yhk'">
                        <div>
                            <span>银行卡账号：</span>
                            <el-input placeholder="输入银行卡账号" v-model="recentbankinfo.accountno" clearable></el-input>
                        </div>
                        <div>
                            <span>开户姓名：</span>
                            <el-input placeholder="输入姓名" v-model="recentbankinfo.accountname" clearable></el-input>
                        </div>
                        <div>
                            <span>开户银行：</span>
                            <el-input placeholder="输入开户行" v-model="recentbankinfo.bankname" clearable></el-input>
                        </div>
                        <div>
                            <span>开户城市：</span>
                            <el-input placeholder="输入开户行城市" v-model="recentbankinfo.bankcity" clearable></el-input>
                        </div>
                        <div>
                            <span>开户行分行：</span>
                            <el-input placeholder="输入开户行分行" v-model="recentbankinfo.banksubname" clearable></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="info_box" v-if="tabPosition === 'wxzh'&&wxinfo.bindstatus===1">
            <span>提现金额：</span>
            <div>
                <el-input type="number" placeholder="0.00" v-model="money" :min="minMoney" :max="maxMoney"></el-input>
            </div>
            <div class="jrytx" v-if="tabPosition === 'zfb'||tabPosition === 'yhk'||tabPosition === 'wxzh'">
                <span>{{user.systypecode === '2' ? '提现费用' : '手续费金额'}}：<b>{{serviceCharge}}</b>元</span>
                <span>实际到账金额：<b>{{lastMoney}}</b>元</span>
            </div>
        </div>
        <div class="info_box" v-if="tabPosition !== 'wxzh'">
            <span>提现金额：</span>
            <div>
                <el-input type="number" placeholder="0.00" v-model="money" :min="minMoney" :max="maxMoney"></el-input>
            </div>
            <div class="jrytx" v-if="tabPosition === 'zfb'||tabPosition === 'yhk'">
                <span>{{user.systypecode === '2' ? '提现费用' : '手续费金额'}}：<b>{{serviceCharge}}</b>元</span>
                <span>实际到账金额：<b>{{lastMoney}}</b>元</span>
            </div>
        </div>
        <div class="info_box" v-if="tabPosition !== 'wxzh'">
            <span>提现说明：</span>
            <el-button type="primary" @click="withdrawBtn">立即提现</el-button>
        </div>
        <div class="info_box" v-if="tabPosition === 'wxzh'&&wxinfo.bindstatus===1">
            <span>提现说明：</span>
            <el-button type="primary" @click="withdrawBtn">立即提现</el-button>
        </div>
        <!--手续费-->
        <div class="serviceCharge_wrap" v-if="user.systypecode !== '2'">
            <div class="serviceCharge" v-if="tabPosition === 'wxzh'&&wxinfo.bindstatus===1">
                <p>· 每笔在 0.3 到 1000 元之间 （不超过 10 笔/天）；</p>
                <p>· 提现上限 20000 元/天；</p>
                <p>· 提现到零钱立即到账</p>
            </div>
            <div class="serviceCharge" v-if="tabPosition === 'zfb'">
                <p>· 手续费：</p>
                <p class="noDian">提现金额的 0.15%；</p>
                <p class="noDian">单笔最低 2 元，最高 25 元；</p>
                <p> · 提现上限 10 万/天，最低 5 元；</p>
                <p> · 提现到支付宝到账时间为 T+1；</p>
            </div>
            <div class="serviceCharge" v-if="tabPosition === 'yhk'">
                <p>· 手续费：</p>
                <p class="noDian">5 元/笔 （1 万元以下，含 1 万元）；</p>
                <p class="noDian">10 元/笔 （ 1 到 10 万，含 10 万）；</p>
                <p class="noDian">15 元/笔  （10 万到 50 万，含 50 万）；</p>
                <p class="noDian">20 元/笔 （50 万至 100 万，含100 万）；</p>
                <p class="noDian">0.002%/笔 （100 万以上按金额 ）；</p>
                <p class="noDian">最高 200 元/笔；</p>
                <p> · 提现上限 100 万/天，最低 5 元；</p>
                <p> · 提现到银行卡高级用户到账时间为 T+1，普通用户到账时间为 T+3</p>
            </div>
            <div class="serviceCharge" v-if="tabPosition === 'zhye'">
                <p> · 提现到账户余额后资金不能从余额中提现 ；</p>
                <p> · 提现到账户余额立即到账；</p>
            </div>
        </div>
        <div class="serviceCharge_wrap" v-else>
            <div class="serviceCharge">
                <p class="noDian">1、实际到账金额=税前收益-税前收益*7.2%；</p>
                <p>【7.2%=应交增值税税金6%+应交城市维护建设税税金（税金的7%）+应交教育费附加税金（税金的3%）+应交地方教育附加税金(税金的2%）】</p>
                <p class="noDian">2、 提现上限 10 万/天，最低 5 元；</p>
                <p class="noDian">3、提现到银行卡高级用户到账时间为 T+1，普通用户到账时间为 T+3。</p>
            </div>
        </div>
        <!--弹窗-->
        <el-dialog title="扫描二维码" :visible.sync="dialogVisible" width="600">
            <div class="wxqrcode_box">
                <img :src="wxinfo.wxqrcode" alt="">
                <p>使用微信零钱需先扫码二维码，关注公众号！</p>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">暂不关注</el-button>
            <el-button type="primary" @click="withdrawalClick">我已关注，立即提现</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
import {findHostMoney, balanceTransfer,getHostCashInfo,balanceTransferV2} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {getQueryParams} from 'common/js/tools'
export default {
    name: 'Withdrawal',
    props: ['hostroletype'],
    data() {
        return {
            accountinfo:{}, //账户信息
            recentalipayinfo:{}, //支付宝信息
            recentbankinfo:{}, //银行卡信息
            wxinfo:{}, //微信信息
            serviceCharge:0, //手续费
            lastMoney:0, //最后到账金额
            isInput:false, //是否可填写
            minMoney:'', //最小提现值
            maxMoney:'', //最大提现值
            dialogVisible: false, //授权弹窗

            cashbalance: 0, // 可提现余额
            linkman: '', // 账户名称
            linktel: '', // 账户手机号

            realName: '', // 真实姓名
            alipay: '', // 支付宝账号

            bankCard: '', // 银行卡账号
            accountName: '', // 开户姓名
            bankName: '', // 开户银行
            bankCity: '', // 开户城市
            bankBranch: '', // 开户行分行

            money: '', // 提现金额
            todaycashmoney: '', // 今日已提现金额
            tabPosition: 'wxzh',
            hostroleinnerid: ''
        }
    },
    mounted() {
        if (this.hostroletype == 2) {
            this.hostroleinnerid = this.brandBusiness.hostid
        } else if (this.hostroletype == 4) {
            this.hostroleinnerid = this.user.providerinnerid
        } else {
            this.hostroleinnerid = ''
        }
        this.getFindHostMoney()
        if (this.$route.query.token) {
            this.init()
        }
    },
    methods: {
        init() {
            this.setParams()
        },
        setParams() {
            let path = window.location.pathname
            let params = getQueryParams()
            delete params.token
            delete params.expiretime
            this.$router.push({path: `${path}`, query: params})
        },
        tabChange() {
            this.money = ''
        },
        withdrawalClick(){
            this.dialogVisible=false;
            this.getFindHostMoney()
        },
        // 获取可提现余额
        getFindHostMoney() {
            this.setLoading(true)
            getHostCashInfo({
                data: {
                    hostroletype: this.hostroletype,
                    hostroleinnerid: this.hostroleinnerid,
                    // reurl:window.location.href.split('?')[0],
                    // // reurl:window.location.origin + window.location.pathname
                    reurl:window.location.href
                },
                success: data => {
                    this.setLoading(false)
                    console.log(data)
                    this.accountinfo=data.data.accountinfo
                    this.recentalipayinfo=data.data.recentalipayinfo
                    this.recentbankinfo=data.data.recentbankinfo
                    this.wxinfo=data.data.wxinfo
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 点击去授权
        goAuthorize(){
            this.dialogVisible=true
            // window.open(this.wxinfo.bindurl)
            // location.href=this.wxinfo.bindurl
        },
        // 立即提现
        withdrawBtn() {
            let params = {};
            switch (this.tabPosition) {
            case 'zhye':
                params = {
                    money: this.money,
                    cashtype: 1,
                    feemoney:0,
                    accountmoney:this.money,
                };
                break;
            case 'zfb':
                params = {
                    money: this.money,
                    cashtype: 2,
                    accountname: this.recentalipayinfo.accountname,
                    accountno: this.recentalipayinfo.accountno,
                    feemoney:this.serviceCharge,
                    accountmoney:this.lastMoney,
                };
                break;
            case 'wxzh':
                params = {
                    money: this.money,
                    cashtype: 3,
                    feemoney:this.serviceCharge,
                    accountmoney:this.lastMoney,
                };
                break;
            case 'yhk':
                params = {
                    money: this.money,
                    cashtype: 4,
                    accountname: this.recentbankinfo.accountname,
                    accountno: this.recentbankinfo.accountno,
                    bankcity: this.recentbankinfo.bankcity,
                    banksubname: this.recentbankinfo.banksubname,
                    bankname: this.recentbankinfo.bankname,
                    feemoney:this.serviceCharge,
                    accountmoney:this.lastMoney,
                };
                break
            }
            if (this.tabPosition === 'zfb') {
                if (this.recentalipayinfo.accountname === '') {
                    this.$message.error(`请输入支付宝账号姓名！`)
                    return
                }
                if (this.recentalipayinfo.accountno === '') {
                    this.$message.error(`请输入支付宝账号！`)
                    return
                }
            } else if (this.tabPosition === 'yhk') {
                if (this.recentbankinfo.accountno === '') {
                    this.$message.error(`请输入银行卡账号！`)
                    return
                }
                if (this.recentbankinfo.accountname === '') {
                    this.$message.error(`请输入开户姓名！`)
                    return
                }
                if (this.recentbankinfo.bankname === '') {
                    this.$message.error(`请输入开户银行！`)
                    return
                }
                if (this.recentbankinfo.bankcity === '') {
                    this.$message.error(`请输入开户行城市！`)
                    return
                }
            }
            if (this.money === '') {
                this.$message.error(`请输入提现金额！`)
            }else if(this.money<this.minMoney || this.money>this.maxMoney){
                this.$message.error(`请输入正确的提现金额！`)
            }else {
                if (parseFloat(params.money) > parseFloat(this.accountinfo.cashbalance)) {
                    this.$message.error(`提现金额不能大于可提现余额！`)
                } else {
                    this.withdraw(params)
                }
            }
        },
        withdraw(value) {
            this.setLoading(true);
            balanceTransferV2({
                data: Object.assign({}, value, {hostroletype: this.hostroletype, hostroleinnerid: this.hostroleinnerid}),
                success: data => {
                    this.setLoading(false)
                    if (this.hostroletype == 2 || this.hostroletype == 4) {
                        this.$message.success(`发起提现成功，3秒后将进行跳转！`)
                        setTimeout(() => {
                                this.$router.back()
                        }, 3000)
                    } else {
                        this.$message.success(`发起提现成功，3秒后将跳转到财务管理首页！`)
                        setTimeout(() => {
                            this.$router.push({name: 'FManagement'})
                        }, 3000)
                    }
                },
                error: data => {
                    console.log('error：', data);
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 手续费、实际到账换算
        exchangeMoney() {
            let money=Math.round(this.money*100) / 100;
            if(money>parseFloat(this.accountinfo.cashbalance)){
                this.$message.error(`提现金额不能大于可提现余额！`)
            }else if(money===''){
                this.serviceCharge=0;
                this.lastMoney=0;
            }else{
                if (this.user.systypecode === '2') {
                    this.minMoney=5;
                    this.maxMoney=100000;
                    if(money<this.minMoney || money>this.maxMoney){
                        this.serviceCharge=0
                        this.lastMoney=0
                        return
                    }
                    this.serviceCharge=(money*0.072).toFixed(2);
                    // if(this.serviceCharge<2){
                    //     this.serviceCharge=2
                    // }
                    // else if(this.serviceCharge>25){
                    //     this.serviceCharge=25
                    // }
                    this.lastMoney=(money-this.serviceCharge).toFixed(2);
                } else {
                    switch (this.tabPosition) {
                        case 'zfb':
                            this.minMoney=5;
                            this.maxMoney=100000;
                            if(money<this.minMoney || money>this.maxMoney){
                                this.serviceCharge=0
                                this.lastMoney=0
                                return
                            }
                            this.serviceCharge=(money*0.0015).toFixed(2);
                            if(this.serviceCharge<2){
                                this.serviceCharge=2
                            }
                            else if(this.serviceCharge>25){
                                this.serviceCharge=25
                            }
                            this.lastMoney=(money-this.serviceCharge).toFixed(2);
                            break;
                        case 'yhk':
                            this.minMoney=5;
                            this.maxMoney=1000000;
                            if(money<this.minMoney || money>this.maxMoney){
                                this.serviceCharge=0
                                this.lastMoney=0
                                return
                            }
                            if(money<=10000){
                                this.serviceCharge=5;
                            }else if(money<=100000){
                                this.serviceCharge=10;
                            }else if(money<=500000){
                                this.serviceCharge=15;
                            }else if(money<=1000000){
                                this.serviceCharge=20;
                            }else if(money>1000000){
                                this.serviceCharge=(money*0.00002).toFixed(2);
                                if(this.serviceCharge>=200){
                                    this.serviceCharge=200;
                                }
                            }
                            this.lastMoney=(money-this.serviceCharge).toFixed(2);
                            break;
                        case 'wxzh':
                            this.minMoney=0.3;
                            this.maxMoney=1000;
                            if(money<this.minMoney || money>this.maxMoney){
                                this.serviceCharge=0
                                this.lastMoney=0
                                return
                            }
                            break;
                        case 'zhye':
                            this.minMoney=0;
                            this.maxMoney=99999999;
                            if(money<this.minMoney || money>this.maxMoney){
                                this.serviceCharge=0
                                this.lastMoney=0
                                return
                            }
                            break;
                    }
                }
                
            }
        },
        ...mapActions([
            'setLoading',
            'setUser',
        ])
    },
    watch: {
        money(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.exchangeMoney()
                // console.log(this.money)
            })
        }
    },
    filters: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'brandBusiness'
        ])
    },
    components: {}
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .withdrawal {
        /*手续费*/
        .serviceCharge{
            padding-left: 110px;
            padding-top: 10px;
            .noDian{
                padding-left: 10px;
            }
            p{
                color: #909399;
                line-height:35px;
            }
        }
        padding: 30px 20px;
        padding-bottom: 100px;
        .top{
            p{
                padding-left: 10px;
                border-left: 2px solid #409eff;
                font-size: 16px;
                font-family: PingFangSC-Medium;
                font-weight: bold;
                color: rgba(48, 49, 51, 1);
            }
        }
        .info_box{
            margin-top: 20px;
            display: flex;
            align-items: center;
            height: 50px;
            &>span{
                white-space: nowrap;
            }
            &>span:nth-of-type(1){
                margin-right: 10px;
                display: inline-block;
                width: 100px;
                text-align: justify;
            }
            .jrytx{
                margin-left: 30px;
                span:first-child{
                    margin-right: 20px;
                }
                span{
                    b{
                        color: #F56C6C;
                    }
                }
            }
            .el-input__inner {
                height: 32px;
                line-height: 32px;
                padding: 0 15px;
                width: 247px;;
            }
        }
        .ktxye{
            margin-top: 15px;
            &>span:nth-of-type(2){
                font-size:24px;
                color:rgb(216, 161, 161);
            }
        }
        .info_box:nth-of-type(3){
            display: flex;
            align-items: flex-start;
            height: auto;
            .select_box{
                .select_box_top{
                    white-space: nowrap;
                    .el-radio-button{
                        margin-right: 30px;
                    }
                    .el-radio-button:nth-of-type(4){
                        margin-right: 0px;
                    }
                    .el-radio-button__inner {
                        white-space: nowrap;
                        width: 180px;
                        height: 50px;
                        padding: 16px 20px;
                        border:1px solid rgba(220,223,230,1);
                        border-radius: 4px;
                        color: #303133;
                    }
                    .el-radio-button__inner:hover {
                        border:1px solid rgba(64,158,255,1);
                        color: #409EFF;
                        background-image: url('../../../common/images/other/select_icon.png');
                        background-size:28px 28px !important;
                        background-repeat: no-repeat;
                        background-position: top left;
                        background-origin:border-box;
                    }
                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        color: #303133;
                        background-color: rgb(251, 251, 251);
                        color: #409EFF;
                        -webkit-box-shadow: -1px 0 0 0 rgb(255, 255, 255);
                        box-shadow: -1px 0 0 0 rgb(255, 255, 255);
                        border:1px solid rgba(64,158,255,1);
                        background-image: url('../../../common/images/other/select_icon.png');
                        background-size:28px 28px !important;
                        background-repeat: no-repeat;
                        background-position: top left;
                        background-origin:border-box;
                    }
                }
                .select_box_bottom{
                    background-color: #F5F7FA;
                    margin-top: 10px;
                    &>div{
                        padding: 20px 30px;
                    }
                    .el-input__icon {
                        line-height: 32px;
                    }
                    .zhye_box{
                        padding: 20px 30px 10px;
                        p:nth-of-type(1){
                            margin-bottom: 10px;
                            line-height:20px;
                            span:nth-of-type(1), span:nth-of-type(3){
                                margin-right: 10px;
                                color: #303133;
                            }
                            span:nth-of-type(2), span:nth-of-type(4){
                                margin-right: 50px;
                                color: #606266;
                            }
                            span:nth-of-type(4){
                                margin-right: 0px;
                            }
                        }
                        p:nth-of-type(2){
                            color: #F56C6C;
                            line-height:20px;
                        }
                    }
                    .wxzh_box{
                        /*&>div{*/
                            /*display: flex;*/
                            /*align-items: center;*/
                            /*margin-bottom: 10px;*/
                            /*span{*/
                                /*white-space: nowrap;*/
                            /*}*/
                        /*}*/
                        /*&>p{*/
                            /*color: #F56C6C;*/
                            /*line-height:20px;*/
                        /*}*/
                        .noAuthorize{
                            span{
                                color: #409EFF;
                                cursor: pointer;
                            }
                        }
                        .hasAuthorize{
                            p{
                                display: flex;
                                align-items: center;
                                margin:20px 0;
                                font-size: 14px;
                                img{
                                    width: 30px;
                                    height: 30px;
                                    background: gray;
                                    border-radius: 50%;
                                    margin-right: 10px;
                                    display: inline-block;
                                    vertical-align: middle;
                                }
                            }
                            .goAuthorize{
                                color: #409EFF;
                                cursor: pointer;
                            }
                        }
                    }
                    .zfb_box{
                        .el-input {
                            width: 260px;
                        }
                        &>div{
                            display: flex;
                            align-items: center;
                            span{
                                white-space: nowrap;
                                display: inline-block;
                                width: 140px;
                                text-align: right;
                                margin-right: 10px;
                            }
                        }
                        &>div:nth-of-type(1){
                            margin-bottom: 15px;
                        }
                    }
                    .yhk_box{
                        .el-input {
                            width: 280px;
                        }
                        &>div{
                            display: flex;
                            align-items: center;
                            margin-bottom: 15px;
                            span{
                                white-space: nowrap;
                                display: inline-block;
                                width: 106px;
                                text-align: right;
                                margin-right: 30px;
                            }
                        }
                        &>div:nth-last-of-type(1){
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
    .wxqrcode_box{
        text-align: center;
        img{
            width: 140px;
            height: 140px;
            margin-bottom: 20px;
        }
        p{
            color: #C0C4CC;
            font-size: 14px;
        }
    }
    /*弹窗样式*/
    .el-dialog .el-button{
        padding: 0 10px;
    }
</style>
